import { render } from "./PaymentError.vue?vue&type=template&id=28ef7e82&ts=true"
import script from "./PaymentError.vue?vue&type=script&lang=ts"
export * from "./PaymentError.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__